// react
import { useNavigate } from 'react-router-dom';
import { DYNAMIC_ROUTES } from 'router';

// store
import { useGetAllArticleFilteredQuery } from 'store/api/cms';
import { getAccount } from 'store/slices/iamSlice';
import { useSelector } from 'store';

// components
import ArticleList from '@karehero/llama/components/pages/ArticleList/ArticleList';
import { PageTemplate } from '@karehero/llama/pwa/templates/PageTemplate/PageTemplate';
import { PageHeader } from '@karehero/llama/pwa/atoms/PageHeader/PageHeader';

/**
 * SJPResources shows the content library.
 */
export const SJPResources = () => {
  // hooks
  const navigate = useNavigate();
  const { data: articles, isLoading } = useGetAllArticleFilteredQuery();
  const account = useSelector(getAccount);

  return (
    <PageTemplate
      maxWidth='xl'
      headerSlot={
        <PageHeader title={`${account?.organization?.name || ''} Resources`} />
      }
      contentSlot={
        <ArticleList
          articles={articles}
          isLoading={isLoading}
          organizationName={account?.organization?.name}
          isHeaderHidden
          onArticleClick={(article) =>
            navigate(DYNAMIC_ROUTES.LIBRARY_ARTICLE(article?.slug?.current))
          }
        />
      }
    />
  );
};

export default SJPResources;
